/* eslint-disable no-unused-vars */
import {addVendorLoadedEventListener, initVendorConsentsLoader} from '@adv-mt/consent-vendors-loader'

import {isCoches} from '../../config/index.js'
import config, {CRITEO, GOOGLE_ADS, RTB_HOUSE} from './config.js'
import {googleAdsScriptUrl} from './getScriptsUrls.js'
import {onLoadCriteoScript, onLoadGoogleAdsScript, onLoadRtbHouseScript} from './onLoadScripts.js'

initVendorConsentsLoader({
  vendors: {
    [CRITEO]: {
      script: config[CRITEO].SCRIPT_URL,
      consents: {
        purposes: [1, 2, 3, 4, 7]
      }
    },
    ...(isCoches && {
      [GOOGLE_ADS]: {
        script: googleAdsScriptUrl,
        consents: {
          purposes: [2, 6, 7, 8, 9]
        }
      }
    }),
    ...(isCoches && {
      [RTB_HOUSE]: {
        consents: {
          purposes: [1, 2, 3, 4, 7]
        }
      }
    })
  }
})

addVendorLoadedEventListener(({vendor}) => {
  switch (vendor) {
    case CRITEO:
      return onLoadCriteoScript()
    case GOOGLE_ADS:
      return onLoadGoogleAdsScript()
    case RTB_HOUSE:
      return onLoadRtbHouseScript()
    default:
      break
  }
})
